// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aQhg_","slidePicture":"styles_slidePicture__25Bq7","slideInfo":"styles_slideInfo__1RU2Z","slid":"styles_slid__l0S8O"};